import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Button, Link, Paper, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

const PREFIX = 'InternalLoginForm';

const classes = {
  container: `${PREFIX}-container`,
  form: `${PREFIX}-form`,
  title: `${PREFIX}-title`,
  submit: `${PREFIX}-submit`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    width: 305,
    padding: 32,
  },

  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
  },

  [`& .${classes.title}`]: {
    fontSize: 21,
    fontFamily: 'Bitter',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },

  [`& .${classes.submit}`]: {
    marginTop: theme.spacing(4),
  },
}));

interface InternalLoginFormProps {
  returnPage?: string;
  submit: (info: any) => void;
}

export default function InternalLoginForm({
  returnPage,
  submit,
}: InternalLoginFormProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const requiredFieldMessage = t('common.requiredField');
  const { handleSubmit } = useForm();

  return (
    <Root className={classes.container}>
      <Typography className={classes.title}>{t('login.loginTitle')}</Typography>
      <form onSubmit={handleSubmit(submit)} className={classes.form}>
        <Button
          color="primary"
          variant="contained"
          className={classes.submit}
          type="submit">
          {t('login.login')}
        </Button>
      </form>
      <Link
        href="#"
        onClick={(evt: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          evt.preventDefault();
          navigate(`/login?returnPage=${returnPage}`);
        }}
        color="primary"
        underline="always"
        align="center">
        <Typography variant="body2">{t('login.externalLogin')}</Typography>
      </Link>
    </Root>
  );
}
